import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import Backend from "i18next-http-backend";

import ru from "./translation/ru.json";
import en from "./translation/en.json";
import am from "./translation/am.json";
import meta from "./translation/meta.json";

const resources = {
  am: { translation: { ...am, meta: meta.am } },
  ru: { translation: { ...ru, meta: meta.ru } },
  en: { translation: { ...en, meta: meta.en } },
};

const savedLang = localStorage.getItem("language") || "am";

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "am",
    lng: savedLang,

    detection: {
      order: ["localStorage", "cookie", "navigator"],
      caches: ["localStorage"],
    },

    react: {
      useSuspense: false,
    },

    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;